import styled from "styled-components";

export const AmountFieldsGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 16px;
	width: 100%;
	align-items: start;

	@media (min-width: 768px) {
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 12px;
	}
`;
